import { NavigateFunction } from 'react-router-dom';
import { DeliveringPath } from '../../enums/DeliveryNavigatePathEnum';
import {PickingUpPath} from "../../enums/PickUpNavigatePathEnum";

/**
 * 公共跳转组件
 */
export const navigateBack = {
  navigateToLsatPage: (navigate: NavigateFunction) => navigate(-1),
  navigateToDeliveringList: (navigate: NavigateFunction) => navigate(DeliveringPath.DELIVERY_DELIVERING),
  navigateToPickupList: (navigate: NavigateFunction) => navigate(PickingUpPath.PICKUP_PICKINGUP),
};
